module.exports = __webpack_public_path__ + "static/media/provozovna (6).c1060d10.png";